import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-truckowner-payment",
  templateUrl: "./admin-truckowner-payment.component.html",
  styleUrls: ["./admin-truckowner-payment.component.css"],
})
export class AdminTruckownerPaymentComponent implements OnInit {
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  @Input() min: any;
  minDate = new Date();
  token: any;
  paymentForm: FormGroup;
  isSaving = false;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminTruckownerPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");

    const accountDetails = this.data?.truckownerInfo?.[0]?.account_details;
    const accountNo = accountDetails?.accountr_number || accountDetails?.account_number || "";
    const bankName = accountDetails?.bank_name || "";

    this.paymentForm = this.formBuilder.group({
      transaction_id: ["", [Validators.required]],
      transaction_amount: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
        ]),
      ],
      payment_date: ["", [Validators.required]],
      payment_type: ["", [Validators.required]],
      account_no: [accountNo, [Validators.required]],
      bank_name: [bankName, [Validators.required]],
    });
  }
  close() {
    this.matdialogref.close();
  }
  save() {
    if (this.paymentForm.invalid) {
      this.snackBar.open("Please fill all mandatory fields correctly.", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.isSaving = true;
    let actual_amount = this.data.paymentInfo?.[0]?.price_details?.actual_price;
    if (!actual_amount && this.data.userInfo?.[0]?.user_type === 'corporate') {
      const payAs = this.data.workOrderInfo?.[0]?.pay_as_load_quantity;
      const otherDetails = this.data.workOrderOtherDetails;
      if (payAs === 'loaded_quantity') {
        actual_amount = (otherDetails?.loading_point && otherDetails?.price_per_ton) 
          ? (otherDetails.loading_point * otherDetails.price_per_ton) 
          : 0;
      } else if (payAs === 'unloaded_quantity') {
        const qty = otherDetails?.unloading_point || otherDetails?.loading_point;
        actual_amount = (qty && otherDetails?.price_per_ton) 
          ? (qty * otherDetails.price_per_ton) 
          : 0;
      } else {
        actual_amount = 0;
      }
    }

    const paymentObj = {
      truckowner_id: this.data.truckowner_id,
      actual_amount: actual_amount,
      transaction_id: this.paymentForm.value.transaction_id,
      transaction_amount: Number(this.paymentForm.value.transaction_amount),
      account_no: Number(this.paymentForm.value.account_no),
      bank_name: this.paymentForm.value.bank_name.toLowerCase(),
      payment_type: this.paymentForm.value.payment_type.toLowerCase(),
      payment_date: this.paymentForm.value.payment_date,
    };
    this.services.addPayment(this.token, paymentObj, this.data._id).subscribe(
      (response: any) => {
        this.isSaving = false;
        if (response.status == 200 && !response.body.message) {
          this.matdialogref.close();
        } else if (response.status == 200 && response.body.message) {
          this.snackBar.open(response.body.message, "Fail", {
            duration: 5000,
          });
        }
      },

      (error) => {
        this.isSaving = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
